import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 0 100px var(--box-shadow-color);
    -moz-box-shadow: 0 0 100px var(--box-shadow-color);
    box-shadow: 0 0 100px var(--box-shadow-color);
    border-radius: 10px;
    z-index: 99;
  }
  .popUpContainer.width-500 {
    width: 100%;
    max-width: 500px;
  }
  article {
    max-height: 800px;
    height: fit-content;
    background-color: var(--modal-pad-background);
    backdrop-filter: blur(25px);
    border-radius: 10px 10px 10px 10px;
    padding: 0 0 0 0;
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 30px 0 0 30px;
  }

  .popup:target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/share-card.css */
  @media (max-width: 1200px) {
    a.closePopUp {
      left: 25px;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/fees_calc.css */
  ul,
  li {
    list-style: disc;
    font-size: 0.8rem;
    line-height: 130%;
  }
  ul {
    margin: 10px 0 0 30px;
    width: 100%;
    padding: 10px 30px 0 15px;
  }
  li {
    margin: 0 0 10px 0;
  }
  li:last-child {
    margin: 0;
  }
  .fees_calc .subtitle {
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
    padding: 15px 0 0 30px;
  }
  .fees_calc .fees_on_profit_wrap {
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
  }
  .fees_calc .upfront_fees_wrap {
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
  }
  .fees_calc .grid-body.fees_tables {
    display: grid;
    grid-template-columns: 1fr;
    overflow: hidden;
    width: 100%;
    padding: 15px 0 0 30px;
  }
  .grid-header {
    display: flex;
    height: fit-content;
    width: 100%;
    justify-content: center;
  }
  .fees_calc .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .fees_calc .grid-content label {
    font-size: 0.8rem;
  }
  .fees_calc .grid-content label {
    padding: 6px 8px;
    justify-content: center;
    display: flex;
    min-height: 25px;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.1);
  }
  .fees_calc .grid-header label {
    justify-content: center;
    text-transform: uppercase;
    background: hsla(0, 0%, 0%, 0.2);
    font-size: 0.8rem;
    padding: 10px;
    width: 100%;
    text-align: center;
    margin: 0 0 10px 0;
  }
  .fees_calc .grid-header label:first-child {
    border-right: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .fees_calc .grid-header label:nth-child(2) {
    font-weight: 800;
  }
  .fees_calc .grid-content label:nth-last-child(2),
  .fees_calc .grid-content label:last-child {
    border-bottom: none;
  }
  .fees_calc .footnote {
    padding: 15px 30px 30px 30px;
    font-size: 0.75rem;
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 600px) {
    article {
      height: 80vh;
      max-height: 80vh;
      overflow: auto;
      flex-direction: column;
    }
  }
`

const developerCSS = css``

export const FeesStructureModalCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
